export const CALENDAR = "App\\Calendar";
export const NEWSLETTER = "App\\Newsletter";
